<template>
  <li
  class="flex justify-between items-center py-4">
<!-- discount value -->
    <div 
    :style="discountListItemValueColor"
    class="w-1/4 "
    v-currency="coupon.value" 
    v-show="coupon.type != 'Percentage'"/>

    <div 
    :style="discountListItemValueColor"
    class="w-1/4 "
    v-show="coupon.type == 'Percentage'">{{coupon.value}}%</div>
<!-- discount code title and description -->
    <div class="flex-grow">
      <strong>{{ coupon.code }}</strong>
      <br/>
      <small>{{ coupon.description }}</small>
    </div>
<!-- delete discount code from list button -->
    <div 
    :style="discountListItemDeleteButtonBackgroundColor"
    @click="onDeleteCoupon"
    class="cursor-pointer rounded-full p-1.5 flex items-center justify-center">
      <Icon name="x" size="12" :color="discountListItemDeleteButtonIconColor" />
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

import Icon from '../Icon.vue';

export default {
  props: {
    coupon: {
      default: () => {}
    }
  },
  components: { Icon },
  computed: {
    ...mapGetters("Theme", [
      "discountListItemValueColor",
      "discountListItemDeleteButtonBackgroundColor",
      "discountListItemDeleteButtonIconColor",
    ])
  },
  methods: {
    onDeleteCoupon() {
      this.$emit('delete-coupon', this.coupon)
    }
  },
  emits: ['delete-coupon']
}
</script>

<style>

</style>